import { Capitals, isCapitals, isUlid } from "../../../api/request/PricingCandidates/types";

export interface CandidateIntent { candidateId: string; capitalsByTrait: Capitals; }
export interface SelectionIntent { selectionId: string; candidateId: string; }
export interface Intents { version: 1; candidates: CandidateIntent[]; selections: SelectionIntent[]; }
const key = (lead: string) => `life5:pricing-candidates:v1:${lead}`;

export function readIntents(lead: string, storage: Storage): Intents {
  if (!isUlid(lead)) throw new Error("INVALID_CANDIDATE_IDENTITY");
  const raw = storage.getItem(key(lead));
  if (raw === null) return { version: 1, candidates: [], selections: [] };
  const value = JSON.parse(raw);
  if (value?.version !== 1 || Object.keys(value).sort().join() !== "candidates,selections,version"
    || !Array.isArray(value.candidates) || !Array.isArray(value.selections)
    || !value.candidates.every((i: CandidateIntent) => i && Object.keys(i).sort().join() === "candidateId,capitalsByTrait"
      && isUlid(i.candidateId) && isCapitals(i.capitalsByTrait))
    || !value.selections.every((i: SelectionIntent) => i && Object.keys(i).sort().join() === "candidateId,selectionId"
      && isUlid(i.selectionId) && isUlid(i.candidateId)
      && value.candidates.some((c: CandidateIntent) => c.candidateId === i.candidateId))
    || new Set(value.candidates.map((i: CandidateIntent) => i.candidateId)).size !== value.candidates.length
    || new Set(value.selections.map((i: SelectionIntent) => i.selectionId)).size !== value.selections.length) {
    throw new Error("CANDIDATE_LOCAL_HISTORY_INVALID");
  }
  return value;
}

// Save only references and original options, synchronously BEFORE any write request.
export function addIntent(lead: string, storage: Storage, intent: CandidateIntent | SelectionIntent): Intents {
  const value = readIntents(lead, storage);
  if ("selectionId" in intent) value.selections.push(intent);
  else value.candidates.push(intent);
  storage.setItem(key(lead), JSON.stringify(value));
  return value;
}
